import { FC } from 'react';
import { BaseTab } from '../BaseTab';
import { useTranslation } from 'react-i18next';
import { useCustomPageQuery } from '../../../../../common/queries/use-custom-page-query';
import useIframeResize from '../../../../../common/useIframeResize';
import { Container } from '@socialchorus/shared-ui-components';
import { Spinner } from '../../../../ui';
import styles from './styles.module.scss';

interface Props {
  topicId: string;
  customPageId: string;
  activeTabId: number;
}

const CustomPageTab: FC<Props> = ({ topicId, customPageId, activeTabId }) => {
  const {
    data: customPageData,
    isLoading,
    isError,
  } = useCustomPageQuery(topicId, customPageId);
  const { t } = useTranslation();
  const errorMessage = t('screens.topics.about.error');

  const iframeStyles = `
  body {
    margin: 0;
    padding: 1px 0;
  }
  img {
    max-width: 100%;
  }
  `;

  const modifiedCustomPage = customPageData?.page_content?.replace(
    /(<a.*?)>/g,
    '$1 target="_top">'
  );

  const { height, ref: iframeRef } = useIframeResize({
    styles: iframeStyles,
  });

  return (
    <BaseTab activeTabId={activeTabId} topicId={topicId}>
      <Container className={styles.Container}>
        {isError && !isLoading && <div>{errorMessage}</div>}
        {isLoading && <Spinner />}
        {!isLoading && customPageData && (
          <iframe
            srcDoc={modifiedCustomPage}
            ref={iframeRef}
            title="custom-page"
            className={styles.CustomPageIframe}
            style={height !== undefined ? { height: `${height}px` } : undefined}
            height={height}
            scrolling="no"
          />
        )}
      </Container>
    </BaseTab>
  );
};

export default CustomPageTab;
